/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_TermsInputs */

const es_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminos y Condiciones`)
};

const en_footer_terms = /** @type {(inputs: Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms and Conditions`)
};

/**
* | output |
* | --- |
* | "Terms and Conditions" |
*
* @param {Footer_TermsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const footer_terms = /** @type {((inputs?: Footer_TermsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_TermsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_terms(inputs)
	return en_footer_terms(inputs)
});
export { footer_terms as "footer.terms" }